export default __webpack_public_path__ + "img/e9eca59cc8899e2c1ced410db73de8df.png";